<template>
  <div :class="$options.name">
    <import-data-table
      ref="importDataTable"
      :items="importList || []"
      :pagination="pagination"
      :loading="importDataLoading"
      @onDoReload="onImportDataReloadTable"
    >
      <template v-slot:toolbar-left-actions>
        <data-import-dialog
          v-if="!isRegionMapType && (hasLayerPermission('geometry-write')
            || hasGlobalUserPermissions(['layer-data-edit', 'layer-import']))"
          :object-id="layerObject.id"
          :property-keys="layerObject.form ? layerObject.form.fields : []"
          class="ml-2"
          label="Импорт данных в слой"
          @import-done="doUpdate"
        />
      </template>
    </import-data-table>
  </div>
</template>

<script>
import camelCase from 'lodash/camelCase';
import DataImportDialog from '@/components/dialogs/DataImportDialog.vue';
import ImportDataTable from '@/views/import-data/components/ImportDataTable.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'import-data-tab',

  components: {
    ImportDataTable,
    DataImportDialog,
  },

  props: {
    layerObject: {
      type: Object,
      default: () => ({}),
    },

    layerPermissions: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      importDataLoading: false,
    };
  },

  computed: {
    ...mapState({
      userPermissions: state => state.auth.permissions,
    }),
    ...mapState('importData', {
      importList: 'list',
      pagination: 'pagination',
    }),

    isRegionMapType() {
      return this.layerObject.mapType === 'region';
    },

    hasLayerPermission() {
      return (permission) => this.layerPermissions[permission];
    },

    hasGlobalUserPermissions() {
      return (permissions) => permissions.some((_) => this.userPermissions.includes(camelCase(_)));
    },
  },

  async created() {
    await this.getImportDataList({ extra: { layerObjectId: this.layerObject.id } });
  },

  methods: {
    ...mapActions('importData', {
      getImportDataList: 'getList',
      getImportDataNextPage: 'getNextPage',
    }),

    async onImportDataReloadTable(data) {
      this.importDataLoading = true;

      try {
        await this.getImportDataNextPage({
          layerObjectId: this.layerObject.id,
          perPage: this.pagination.perPage,
          page: data.page ?? 1,
          sortBy: data.sortBy,
          sortDesc: data.sortDesc,
          query: data.query,
        });
      } catch (e) {
        console.log('e', e);
      } finally {
        this.importDataLoading = false;
      }
    },

    doUpdate() {
      this.$refs.importDataTable.doUpdate();
    },
  },
};

</script>
